import { WebConfig } from "../Config/WebConfig";
// export const MIDDILEWARE_SERVER_URL = "https://dev.vinbytes.com/simule-middleware";
// export const MIDDILEWARE_SERVER_URL = "http://labscops.vingroup.in/backend";
// export const MIDDILEWARE_SERVER_URL = "https://simule-vb-middl";
// ForDeployment
export const MIDDILEWARE_SERVER_URL = WebConfig.apiURL;
// ForLocal
// export const MIDDILEWARE_SERVER_URL = "http://localhost:5000";
export const MetaMask_Verify = MIDDILEWARE_SERVER_URL + "/sign";
export const MetaMask_Nonce = MIDDILEWARE_SERVER_URL + "/wallet/nonce";
export const moralisGetAllNFTs = MIDDILEWARE_SERVER_URL + "/getAllNFTs";
export const getMarketplaceList = MIDDILEWARE_SERVER_URL + "/getMarketplaceList";
export const add_list_api = MIDDILEWARE_SERVER_URL + "/addSellList";
export const delete_list_api = MIDDILEWARE_SERVER_URL + "/deleteSellList";
export const getUnclaimedLands = MIDDILEWARE_SERVER_URL + "/getUnclaimedLands";
export const subscribeNewsletterApi = MIDDILEWARE_SERVER_URL + "/subscribe";
